import apiClient, { IresponseDataPaginated } from "@/lib/api";

export interface Plugin {
  id: string;
  accountId: string;
  referenceId: string;
  name: string;
  url: string;
  token: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface GetPluginsParams {
  name?: string;
  status?: string;
  accountId?: string;
  pageIndex?: number;
  pageSize?: number;
}

export const pluginService = {
  async getPlugins(params?: GetPluginsParams): Promise<IresponseDataPaginated<Plugin[]>> {
    const response = await apiClient.get<IresponseDataPaginated<Plugin[]>>("/account-plugins", { params });
    return response.data;
  },
};
